import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { Breadcrumb } from 'gatsby-plugin-breadcrumb'
import { PageHeaderWrap } from './page-header.style'

const PageHeader = ({ pageContext, location, title }) => {
    const { breadcrumb: { crumbs } } = pageContext;
    const disableLinks = [
        "/elements",
        "/category",
        "/profile",
        "/date",
        "/tag",
        "/page",
        "/blog",
        "/blog/page",
        "/blogs"
    ]
    const customCrumbLabel = location.pathname.toLowerCase();
    const crumbLabelArr = customCrumbLabel.split('/');
    const label = crumbLabelArr[crumbLabelArr.length - 1]
    const labelArr = label.split('-');

    const imageData = useStaticQuery(graphql`
        query breadCrumbImgQuery {
            file(relativePath: {eq: "images/bg/title-bar-01-bg.jpg"}) {
                childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH, quality: 70, placeholder: BLURRED)
                }
            }
        }
    `);

    return (
        <PageHeaderWrap>
            <GatsbyImage
                image={imageData.file.childImageSharp.gatsbyImageData}
                alt=""
                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 0 }}
            />
            <div style={{ position: "relative", zIndex: 1 }}>
                <Breadcrumb
                    title={title}
                    crumbs={crumbs}
                    crumbLabel={labelArr.join(' ')}
                    disableLinks={disableLinks}
                />
            </div>
        </PageHeaderWrap>
    )
}

PageHeader.propTypes = {
    pageContext: PropTypes.object,
    location: PropTypes.object,
    title: PropTypes.string
}

export default PageHeader
